import { useEffect, useState } from 'react';

interface Props {
  rect: DOMRect | null;
  onAdd: () => void;
}

export default function SelectionPill({ rect, onAdd }: Props) {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  if (!rect || !mounted) return null;

  // Position above the selection, centred horizontally.
  const top = Math.max(8, rect.top - 44);
  const left = rect.left + rect.width / 2;

  return (
    <div
      className="fixed z-40 -translate-x-1/2 animate-fade-in"
      style={{ top, left }}
    >
      <button
        type="button"
        onMouseDown={(e) => e.preventDefault()}
        onClick={onAdd}
        className="
          inline-flex items-center gap-1.5
          px-3 py-1.5 rounded-full
          bg-fg text-page
          font-mono text-[11px] uppercase tracking-[0.08em] font-medium
          shadow-flare hover:bg-accent hover:text-accent-fg
          transition-colors duration-200
        "
      >
        <span aria-hidden>+</span>
        Comment
      </button>
    </div>
  );
}
